import { Button } from '@abb-procure/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { PAGE_SIZE } from '../../constants';
import { SearchState } from '../../store/search.state';
import { SearchResultList } from '../search-result-list/search-result-list.component';

@Component({
  selector: 'procure-search-results',
  templateUrl: './search-results.component.html',
  styleUrl: './search-results.component.scss',
  imports: [SearchResultList, Button, RouterLink, QuicklinkDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResults {
  protected readonly data = computed(() => {
    const result = this.state.data()?.result;

    const tabs =
      this.state.tabs()?.map((tab) => tab.entityType?.toUpperCase()) ?? [];

    if (!result) {
      return [];
    }

    return tabs.reduce((acc, entry) => {
      if (entry && result[entry]?.values?.length) {
        return [...acc, result[entry]];
      }

      return acc;
    }, []);
  });

  protected readonly recentlyVisitedEntities = computed(
    () => this.state.recentlyVisitedEntities()?.items ?? [],
  );

  protected readonly favoriteEntities = computed(
    () => this.state.favoriteEntities()?.items ?? [],
  );

  protected readonly hasDefaultData = computed(
    () =>
      this.recentlyVisitedEntities().length > 0 ||
      this.favoriteEntities().length > 0,
  );

  protected readonly activeTab = computed(() => this.state.activeTab());
  protected readonly hasSearchTerm = computed(() => this.state.hasSearchTerm());
  protected readonly currentEntity = computed(() => this.state.currentEntity());

  private readonly state = inject(SearchState);

  protected showMore(): void {
    this.state.pageSize.update((size) => size + PAGE_SIZE);
  }

  protected hideSearch(): void {
    this.state.searchVisible.set(false);
  }
}
